import useSWR from "swr"
import { ExternalPartyFullApi } from "../../../apis"

export function useExternalPartiesQuery() {
  return useSWR(
    ["external-parties", "ALL", "FULL"],
    async () =>
      ExternalPartyFullApi.list({
        filter: { isActive: true },
        offset: { limit: 100, skip: 0 },
      }),
    { revalidateOnFocus: false },
  )
}
